import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Header = () => (
	<div class={style.header}>
	<nav>

	<div class="logo">
	<Link href="/">KidSuper Studios </Link> <br></br>
	<span><small>AW23 Preview</small> </span>
	{/* <br/>
	<span><small>60% off all Items</small> </span> */}
	
</div>

		</nav>
	</div>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js